'use strict';

function createGAuserTiming() {
  var timeProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var defaultEvent = {
    event: 'REDUX_GTM_GA_EVENT',
    hitType: 'timing',
    timingCategory: 'unknown category',
    timingLabel: 'unknown label',
    timingVar: 'unknown var',
    timingValue: 'unknown value'
  };
  return Object.assign(defaultEvent, timeProps);
}

module.exports = createGAuserTiming;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-gtm/lib/event-helpers/create-ga-user-timing.js
// module id = 338
// module chunks = 0